import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "@arc/i18n";
import { useAtomValue } from "jotai";
import axiosInstance from ".";
import { authTokenAtom } from "../../atoms/user";
export const useAssets = () => {
    const { t } = useTranslation();
    const authToken = useAtomValue(authTokenAtom);
    return useQuery({
        queryKey: ["assets", authToken],
        queryFn: async () => {
            try {
                const response = await axiosInstance.get("/assets");
                return response.data;
            }
            catch (error) {
                console.error(error);
                toast.error(t("ERRORS.CANT_FETCH"));
                return [];
            }
        },
        enabled: !!authToken,
    });
};
//# sourceMappingURL=useAssets.js.map